// Shared free-text matcher for the live pass boards (TeacherDashboard and
// the admin ActivePassesPanel). Both filter an in-memory set held by
// useSchoolPasses, so this is a plain predicate rather than a server query —
// see the boards' own comments for why filtering can't move server-side
// (they're socket-fed, so a server-filtered fetch would be polluted by
// incoming events that don't match the filter).
//
// Deliberately limited to the two fields the pass cards actually render.
// PassResponse also carries `note`, `approverNote`, `denierNote` and the
// requester/approver/denier/canceller names, but none are displayed on
// either board: matching them would produce cards with no visible reason for
// the match. The notes are additionally staff free-text (see the
// serializer-leak entry in docs/FOLLOW_UPS.md), so keeping them out of the
// search surface is deliberate, not an oversight.

/** The subset of a pass this matcher reads. */
export interface SearchablePass {
  studentName?: string | null;
  destinationName?: string | null;
}

/**
 * Case-insensitive substring match on student name or destination name.
 * An empty/whitespace-only query matches everything.
 */
export function matchesPassQuery(
  pass: SearchablePass,
  query: string
): boolean {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;
  return (
    (pass.studentName ?? '').toLowerCase().includes(needle) ||
    (pass.destinationName ?? '').toLowerCase().includes(needle)
  );
}
